import { apiActionTypes } from '../../middleware';
const base = '@@Containers/RingCategoryListContainer/';

export const GET_CATEGORY_LIST_ACTION_TYPES = apiActionTypes(`${base}GET_CATEGORY_LIST`);
